export default function getPublicUrl(req = null) {
  // Server-side: build full URL from request
  if (req && req.protocol && req.get) {
    return `${req.protocol}://${req.get('host')}`;
  }

  // Client-side: use window.location.origin
  if (typeof window !== 'undefined' && window.location) {
    return window.location.origin;
  }

  // Fallback (e.g., during build or SSR)
  return process.env.PUBLIC_URL || 'http://localhost:3000';
}



// WEBPACK FOOTER //
// ./utils/getPublicUrl.js